/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {

window.boostSDAppConfig.integration =  Object.assign({

wishlists: 'king'

}, window.boostSDAppConfig.integration || {});

}


const updateProductItem = (componentRegistry) => {
  componentRegistry.useComponentPlugin("ProductItem", {
    name: "Add anchor tag",
    enabled: true,
    apply: () => ({
      afterRender(element) {
        try {
          let productData =
            element.getParams()?.props?.product ||
            element.getParams()?.props?.productData ||
            element.getParams()?.props?.data;
          let productItem = document.querySelector(
            '[data-product-id="' + productData.id + '"]'
          );

          if (!productItem) return;
          /** START Boost 221868 */
          let labels = productItem.querySelectorAll('.boost-sd__product-label.boost-sd__product-label--customLabelByTag');
          Array.from(labels).forEach(label => {
            if (label.querySelector('.boost-sd__product-label-text')) {
              let expression = label.querySelector('.boost-sd__product-label-text').innerText.toLowerCase();
              switch(expression) {
                case 'sale':
                  label.style.background = 'rgb(255, 51, 0)';
                  // code block
                  break;
                case 'featured':
                  label.style.background = 'rgb(41 136 11)';
                  // code block
                  break;
                case 'new':
                  label.style.background = '#a1e460';
                  // code block
                  break;
                default:
                  // code block
              }
            }
          })
          /** END Boost 221868 */

          let popup_option_container = productItem.querySelector(
            ".boost-sd__popup-select-option-container"
          );
          
          if (popup_option_container && !popup_option_container.querySelector('a[href^="/products/"]')) {
            let anchorTag =
              '<a href="/products/' + productData.handle + '"></a>';
            popup_option_container.insertAdjacentHTML("afterbegin", anchorTag);
           
          }
        } catch (e) {}
      },
    }),
  });
};


const addAttributeSwatch = (componentRegistry) => {
  componentRegistry.useComponentPlugin("ProductSwatchOption", {
    name: "Add attribute",
    enabled: true,
    apply: () => ({
      props: (props) => {
        return props;
      },
      afterRender(element) {
        try {
          let label = element.getParentElm().getParams().props.label;
          let rootElm = element.getRootElm();
          if (rootElm.querySelector(".boost-sd__radio-input")) {
            const swatchInput = rootElm.querySelector(".boost-sd__radio-input");
            swatchInput.setAttribute("name", label);
          }
        } catch (error) {
          console.log(error);
        }
      },
    }),
  });
};

const productPriceFormat = (componentRegistry) => {
  componentRegistry.useComponentPlugin('FormatCurrency', {
     name: 'Show Trailing Zeros',
     apply: () => ({
        afterRender: (element) => {
           try {
              // Start customization--------------------------------------------
              const formatMoneyHelper = element.getHelpers().formatMoney;
                                if (!formatMoneyHelper) return;
              const value = element.getParams().props.value; // Get price
              const customValue = formatMoneyHelper(Number(value), window.boostSDAppConfig?.shop?.money_format, true);

              element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = customValue;
             if (element.getParams().props.value < 1) {
               element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = '';
             }
              // End-------------------------------------------------------------
           } catch (e) {
              console.error(e);
           }
        },
     }),
  });
}


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  updateProductItem,
  addAttributeSwatch,
  productPriceFormat
]);







const customize = {
  moveHeaderDescription: (componentRegistry) => {
    componentRegistry.useComponentPlugin("FilterTree", {
      name: "Move Collection Description Below Product List",
      apply: () => {
         let hasUpdated = false; // Prevent rendering twice
         return {
            afterRender(element) {
               try {
                  const descriptionElement = element.getRootElm();
                 console.log(descriptionElement)
                  if (descriptionElement && !hasUpdated) {
                     hasUpdated = true;

                    const filterNotice = `<div class="boost-filter">Filter By</div>`
                    descriptionElement.insertAdjacentHTML("beforebegin", filterNotice)
                     if (productListContainerElement) {
                        
                     }
                  }
                 setTimeout(() => {
                     if(document.querySelector('.boost-sd__product-list.boost-sd__product-list-grid--4-col.boost-sd__product-list--margin')?.textContent == ''){
                       document.querySelector('button.boost-sd__pagination-button').click();
                     }
                     if(document.querySelector('.boost-sd__product-list.boost-sd__product-list-grid--2-col.boost-sd__product-list--margin')?.textContent == ''){
                       document.querySelector('button.boost-sd__pagination-button').click();
                     }
                  }, 1500) 
               } catch (err) {
                  console.error(err);
               }
            }
         }
      }
   })
  }  
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.moveHeaderDescription]);

/* Boost-220119 */
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    const changeProductImageResolution = {
      name: "Change Product Image resolution",
      apply() {
        return {
          props(props) {
           	props.deviceSizes = [200, 300, 400];
            props.imageSizes = [600, 800, 1000];
            
            return props;
          },
        };
      },
    };

    componentRegistry.useComponentPlugin(
      "ProductImage",
      changeProductImageResolution
    );
  },
]);

/* Boost-220119 */

if(boostSDAppConfig?.generalSettings) {
  boostSDAppConfig.generalSettings.no_image_url = 'https://cdn.shopify.com/s/files/1/0839/5397/5618/files/no-image.jpg?v=1704799320'; //New image link
}
